import { NodeTemplatePart } from '@github/template-parts';
import { TemplateResult } from './template-result.js';
export function processSubTemplate(part, value) {
    if (value instanceof TemplateResult && part instanceof NodeTemplatePart) {
        value.renderInto(part);
        return true;
    }
    return false;
}
//# sourceMappingURL=sub-template.js.map